<app-branding-header-bar></app-branding-header-bar>
<app-informationview class="app-informationview" [viewName]="'releaseplanning'"></app-informationview>

<div id="releaseplanning" cdkDropListGroup [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}">
    <!-- BACKLOG -->
    <app-product-backlog [statuses]="columnStatuses"></app-product-backlog>
    <!-- MAIN VIEW-->
    <div class="sprint-container">
      <!-- HEADER ROW -->
      <div class="header">
        <div class="action-view-label">
          <span>{{'actionview.releaseplanning.sprintbacklog' | translate}}</span>
        </div>
        <!-- ADD SPRINT BUTTON -->
        <div class="big-button add-sprint" (click)="openCardForNewSprint($event)">
          <button mat-icon-button>
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <!-- ACTIONVIEW -->
      <div id="actionview" class="actionview">
        <!-- SCROLL BUTTON LEFT CONTROLS -->
        <div class="big-button scroll-left" (click)="onScrollButtonClicked(true)">
          <button mat-icon-button [disabled]="scrollButtonLeftDisabled">
            <mat-icon>arrow_back_ios_new</mat-icon>
          </button>
        </div>
        <!-- SPRINT COLUMN COMPONENTS HERE -->
        <div id="releaseplanning-column-view" (scroll)="onColumnViewScroll()">
          <div *ngFor="let sprint of sprints">
            <app-releaseplanning-sprint-column
              [sprint]="sprint"
              [projectKey]="projectKey"
              [statuses]="columnStatuses"
              (sprintRemoved)="onSprintRemoved(sprint.id)">
            </app-releaseplanning-sprint-column>
          </div>
        </div>
        <!-- SCROLL BUTTON RIGHT CONTROLS -->
        <div class="big-button scroll-right" (click)="onScrollButtonClicked(false)">
          <button mat-icon-button [disabled]="scrollButtonRightDisabled">
            <mat-icon>arrow_forward_ios</mat-icon>
          </button>
        </div>
      </div>
    </div>
</div>

<app-footerbar></app-footerbar>

